/** A receipt expected before today that has not arrived. */
export function isPastDue(expectedDate: string, today: string): boolean {
  return expectedDate < today;
}
